/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Link, Typography, breakpoints } from '@coursera/cds-core';
import { HelpIcon } from '@coursera/cds-icons';

import TrackedDiv from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/xdp';

const styles = {
  titleContainer: css`
    margin: var(--cds-spacing-100) 0;
    ${breakpoints.down('sm')} {
      margin: 0 0 var(--cds-spacing-100) 0;
    }
  `,
  sectionContainer: css`
    display: flex;
    flex-direction: column;
    ${breakpoints.down('sm')} {
      flex-direction: row;
      align-items: center;
    }
  `,
  textContentContainer: css`
    ${breakpoints.down('sm')} {
      margin-left: var(--cds-spacing-200);
    }
  `,
  trackedDiv: css`
    display: inline-block;
  `,
};

const HelpCenterInfo = () => {
  return (
    <div css={styles.sectionContainer}>
      <HelpIcon />
      <div css={styles.textContentContainer}>
        <div css={styles.titleContainer}>
          <Typography variant="h2semibold" component="h3">
            {_t('More questions')}
          </Typography>
        </div>
        <TrackedDiv trackingName="faq_help_center_link" css={styles.trackedDiv}>
          <Link
            href="https://learner.coursera.help/hc/"
            target="_blank"
            typographyVariant="subtitleMedium"
            variant="quiet"
          >
            {_t('Visit the learner help center')}
          </Link>
        </TrackedDiv>
      </div>
    </div>
  );
};

export default HelpCenterInfo;
